import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import Icon from '../../../../components/AppIcon';


export function EarningsSummaryCard({ title, amount, change, period, icon: Icon, trend }) {
  const isPositive = trend === 'up';

  return (
    <div className="bg-surface p-6 rounded-xl border border-border hover:border-primary transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-3 bg-primary/10 rounded-lg">
            <Icon className="w-6 h-6 text-primary" />
          </div>
          <div>
            <p className="text-sm text-text-secondary">{title}</p>
            <p className="text-xs text-text-secondary mt-1">{period}</p>
          </div>
        </div>
        {change !== null && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg ${
            isPositive ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-400'
          }`}>
            {isPositive ? (
              <TrendingUp className="w-4 h-4" />
            ) : (
              <TrendingDown className="w-4 h-4" />
            )}
            <span className="text-xs font-medium">{Math.abs(change)}%</span>
          </div>
        )}
      </div>
      <div className="mt-2">
        <p className="text-3xl font-bold text-text-primary">
          ${amount?.toFixed(2) || '0.00'}
        </p>
      </div>
    </div>
  );
}